<template>
    <div>
        <div>
            <span>{{name}}</span>
            <span v-if="isActive" class="cs-redLabel">(正在上课)</span>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
export default {
    props: {
        data: {},
    },
    data() {
        return {
            name: '',
            isActive: false
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
            if (!!this.data) {
                this.name = this.data.Name;
                this.isActive = this.data.IsActiveCourse;
            }
        },
    },
    watch: {
        data: function() {
            this.init();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/openCourseNameCell.vue